"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _SVGTextStyle = _interopRequireDefault(require("./SVGTextStyle"));

var _SVGWrapper = _interopRequireDefault(require("./SVGWrapper"));

var SVGText = function SVGText(props) {
  var wrapperProps = props.wrapperProps,
      innerProps = (0, _objectWithoutProperties2.default)(props, ["wrapperProps"]);
  return _react.default.createElement(_SVGWrapper.default, wrapperProps, _react.default.createElement(_SVGTextStyle.default, innerProps));
};

SVGText.propTypes = {
  wrapperProps: _react.PropTypes.any
};
var _default = SVGText;
exports.default = _default;
module.exports = exports.default;